import { onError } from 'utils/helpers'

import controllers from './controllers'
import events from './events'
import groups from './groups'
import tokens from './tokens'
import users from './users'
import logout from './logout'
import { requestConfig } from '../../utils/httpClient'

/**
 *
 * @param {Boolean} isActive
 */
function loading(isActive) {
  return {
    type: 'CONTENT_LOADING',
    isActive,
  }
}

function fetchDetailByID(data) {
  return async dispatch => {
    dispatch({ type: 'CONTENT_LOADING', isLoading: true })

    function onSuccess(response) {
      const { status_id, detail } = response.data
      if (status_id !== 200) {
        throw response
      }

      return detail
    }

    try {
      const response = await requestConfig.get(
        `/api/v1/search_by_id?entity=${data.entityType}&id=${data.entityID}`
      )

      return onSuccess(response)
    } catch (error) {
      throw onError(error)
    } finally {
      dispatch({ type: 'CONTENT_LOADING', isLoading: false })
    }
  }
}

const actions = {
  logout,
  loading,
  controllers,
  events,
  fetchDetailByID,
  groups,
  tokens,
  users,
}

export default actions
